<template>
  <div class="homeTitle">
    <div class="rightMenu">
      <span class="main">
        <router-link to='login'>首页</router-link>
      </span>
      <span class="subMenu main">
        <router-link :to="subLink">{{title}}</router-link>
      </span>
      <span class="subMenu" v-if="subTitle">{{subTitle}}</span>
    </div>
    <span class="title" v-if="!subTitle">{{title}}</span>
  </div>
</template>

<script>
export default {
  name: 'homeTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    subLink: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.homeTitle{
  padding: 50px 10px 69px 0;
  align-items: flex-start;
  .title{
    position: relative;
    font-size: 40px;
    line-height: 38px;
    margin-top: 79px;
    display: inline-block;
    &:after{
      content: '';
      display: block;
      position: absolute;
      background: var(--main-color);
      width: 36px;
      height: 4px;
      border-radius: 2px;
      bottom: -15px;
    }
  }
  .rightMenu{
    font-weight: bold;
    font-size: 14px;
    float: right;
    .main{
      margin-right: 14px;
      font-size: 14px;
      a{
        color: #9F9F9F;
      }
    }
    .subMenu{
      margin-right: 14px;
      a{
        color: #000;
      }
      &.main{
        a{
          color: #9F9F9F;
        }
      }
      &:before{
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        border-left: solid 1px #000;
        border-bottom: solid 1px #000;
        transform: rotate(-135deg) translateY(3px);;
        margin-right: 17px;
      }
    }
  }
}
</style>
